export const characteristics = [
    "Performance Reviews ",
    "Opportunity for Advancement ",
    "Training Received ",
    "Company Policies and Practices ",
    "Responsibilities",
    "Working Hours ",
    "Communication Support by Management",
    "Workload ",
    "Salary",
    "Benefits"
  ];
  
  export const reason2Options = [
    { value: "Other Position", label: "Other Position" },
    { value: "Benefits and Pay", label: "Benefits and Pay" },
    { value: "Dissatisfaction with Work", label: "Dissatisfaction with Work" },
    { value: "Dissatisfied with Type of Work", label: "Dissatisfied with Type of Work" },
    { value: "Opportunity for Advancement", label: "Opportunity for Advancement" },
    { value: "Working Conditions", label: "Working Conditions" },
    { value: "Too Demanding or Stressful", label: "Too Demanding or Stressful" },
    { value: "Working Hours", label: "Working Hours" },
    { value: "Relocation", label: "Relocation" },
    { value: "Supervision", label: "Supervision" },
    { value: "Child Care", label: "Child Care" },
    { value: "Other", label: "Other" }
  ];
  
  export const benefitsOptions = [
    { value: "Opportunity for Advancement", label: "Opportunity for Advancement" },
    { value: "Child Care", label: "Child Care" },
    { value: "Too Demanding or Stressful", label: "Too Demanding or Stressful" },
    { value: "Benefits and Pay", label: "Benefits and Pay" },
    { value: "Working Hours", label: "Working Hours" },
    { value: "Relocation", label: "Relocation" },
    { value: "Supervision", label: "Supervision" },
    { value: "Medical", label: "Medical" },
    { value: "Other", label: "Other" },
  ];

export const fields = [
    { id: 1, label: "Job ID*", type: "select" },
    { id: 2, label: "Candidate Name", type: "name" },
    { id: 3, label: "Date", type: "date" },
    { id: 4, label: "Position", type: "autogen" },
    { id: 5, label: "Department", type: "autogen" },
    { id: 6, label: "Interviewer", type: "select" },
  ];
export const reasonOptions = [
    {label: "Other Position", value: "Other Position"},
    {label: "Dissatisfaction with work", value: "Dissatisfaction with work"},
    {label: "Opportunity for Advancement", value: "Opportunity for Advancement"},
    {label: "Too Demanding or Stressful", value: "Too Demanding or Stressful"},
    {label: "Relocation ", value: "Relocation "},
    {label: "Childcare", value: "Childcare"},
    {label: "Benefits and Pay", value: "Benefits and Pay"},
    {label: "Dissatisfaction with type of work", value: "Dissatisfaction with type of work"},
    {label: "Working Conditions", value: "Working Conditions"},
    {label: "Working Hours", value: "Working Hours"},
    {label: "Supervision ", value: "Supervision "},
    {label: "Other", value: "Other"},
  ];
  
export  const ratings = ["Poor", "Fair", "Good", "Excellent"];